import { createContext, useContext, useState, ReactNode } from "react";
import { FarmData } from "../interfaces/FarmData";
import { UserSettings } from "../interfaces/UserSettings";

interface FarmStateContextType {
    farm?: FarmData;
    setFarm: React.Dispatch<React.SetStateAction<FarmData | undefined>>;
    userSettings: UserSettings | undefined;
    setUserSettings: React.Dispatch<React.SetStateAction<UserSettings | undefined>>;
    farms?: FarmData[];
    setFarms: React.Dispatch<React.SetStateAction<FarmData[] | undefined>>;
    isReady: boolean;
    setIsReady: React.Dispatch<React.SetStateAction<boolean>>;
}

const SharedStateContext = createContext<FarmStateContextType | undefined>(undefined);

export function FarmStateProvider({ children }: { children: ReactNode }) {
    const [farm, setFarm] = useState<FarmData>();
    const [userSettings, setUserSettings] = useState<UserSettings | undefined>();
    const [farms, setFarms] = useState<FarmData[]>();
    const [isReady, setIsReady] = useState<boolean>(false);

    return (
        <SharedStateContext.Provider value={{ farm, setFarm, userSettings, setUserSettings , farms, setFarms, isReady, setIsReady}}>
            {children}
        </SharedStateContext.Provider>
    );
}

export function useSharedState() {
    const context = useContext(SharedStateContext);
    if (!context) {
        throw new Error("useSharedState must be used within a SharedStateProvider");
    }
    return context;
}
